// Action creators

// GET logged in user's profile, runs immediately when the App component mounts

var getProfileFetch = () => {
    console.log("profile actions/getProfileFetch");
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/user/me", {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(resp => resp.json())
                .then(data => {
                    console.log("[profile_actions.js] data in profile_actions: ", data); // gets logged after logging in and refreshing page
                    if (data.message) {
                        // An error will occur if the token is invalid.
                        // If this happens, you may want to remove the invalid token.
                        localStorage.removeItem("token")
                    } else {
                        dispatch(loginUser(data))
                    }
                })
        }
    }
}

var updateProfile = user => {
    console.log("profile actions/updateProfile");
    return dispatch => {
        const token = localStorage.token;
        if (token) {
            return fetch("api/user/update", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(user)
            })
                .then(resp => resp.json())
                .then(data => {
                    if (data.message) {
                        // An error will occur if the token is invalid.
                        // If this happens, you may want to remove the invalid token.
                        localStorage.removeItem("token")
                    } else {
                        console.log(data);
                        dispatch(loginUser(data))
                    }
                })
        }
    }
}

const loginUser = userObj => ({
    type: 'PROFILE_LOAD',
    payload: userObj
})

export default { 'LOAD_PROFILE': getProfileFetch, 'UPDATE_PROFILE': updateProfile };


// WEBPACK FOOTER //
// ./src/actions/profile_actions.js


// WEBPACK FOOTER //
// ./src/actions/profile_actions.js